import { render, staticRenderFns } from "./vswitch.vue?vue&type=template&id=50872d8e&scoped=true&"
import script from "./vswitch.vue?vue&type=script&lang=js&"
export * from "./vswitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50872d8e",
  null
  
)

export default component.exports